<template>
  <base-layout>
    <template #breadcrumbs>
      <ui-breadcrumbs title="Общий отчет"/>
    </template>
    <div width="100%">
      <el-select
        v-model="place"
        v-loading.fullscreen.lock="loading"
        class="col-sm-12"
        placeholder="Select"
        size="large"
        @change="changePlace"
      >
        <el-option
          v-for="(item, index ) in places"
          :key="index"
          :label="item"
          :value="item"
        />
      </el-select>
    </div>
    <el-tabs
      v-model="activeName"
      class="demo-tabs"
    >
      <el-tab-pane label="Общая информация" name="General">
        <div v-if="place">
          <div class="b-field">
            <div>{{ place }}</div>
            <div class="b-latest-date">На {{ toDateString(endWork) }}:</div>
          </div>
          <div class="b-info">
            <div>
              <div>
                <div class="b-info-value">{{ toDateString(startWork) }}</div>
                <div>Начало работы</div>
              </div>
              <div>
                <div class="b-info-value">{{ toDateString(endWork) }}</div>
                <div>Конец работы</div>
              </div>
            </div>
            <div>
              <div>
                <div class="b-info-value">{{ numObjects }}</div>
                <div>Количество <br> объектов</div>
              </div>
              <div>
                <div class="b-info-value">{{ numHorizons }}</div>
                <div>Количество <br> горизонтов</div>
              </div>
            </div>
            <div>
              <div>
                <div class="b-info-value">{{ numProdWells }}</div>
                <div>Количество <br> доб. скважин</div>
              </div>
              <div>
                <div class="b-info-value">{{ numInjWells }}</div>
                <div>Количество <br> нагн. скважин</div>
              </div>
            </div>
          </div>
        </div>
        <div class="b-description">
          <div>Описание</div>
          <div>
            Соображения высшего порядка, а также постоянный количественный рост и сфера нашей активности создаёт
            предпосылки качественно новых шагов для дальнейших направлений развитая системы массового участия. С другой
            стороны дальнейшее развитие различных форм деятельности требует от нас анализа экономической
            целесообразности принимаемых решений. Практический опыт показывает, что рамки и место обучения кадров
            позволяет выполнить важнейшие задания по разработке соответствующих условий активизации
          </div>
        </div>
        <div class="b-map">
          <div>Google Maps</div>
          <div>
            <img v-bind:src="'../images/Map.png'" alt="Google Maps">
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Запросы" name="Reports">
        <el-tabs
          v-model="selectedReport"
          name="ReportsTabs"
          @tab-click="changeReportType"
        >
          <el-tab-pane
            v-for="(item, index) in reports"
            :key="index"
            :label="item.title"
            :name="index"
            :disabled="item.is_disabled"
          />
        </el-tabs>
        <div class="row">
          <report-side-bar
            ref="sideBarReports"
            :field="place"
            :reportData="currentReportData"
            :selectedReport="selectedReport"
            :objects="objects"
            :reports="reports"
            :indicators="indicators"
            :places="places"
            @reportCreated="reportCreated"
          />
          <report-main
            ref="reportMain"
            :report="currentReport"
            :reportData="currentReportData"
            :objects="objects"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="Работа с картами" name="Maps">
        <div class="row">
          <div
            class="row mx-0"
            v-if="objects"
          >
            <el-button
              type="primary"
              @click="toggleMapsSidebar"
            >
              {{ mapsSidebar ? 'Скрыть панель' : 'Показать панель' }}
            </el-button>
          </div>
          <report-side-bar-maps
            v-if="mapsSidebar"
            ref="sideBarMaps"
            class="col-5"
            :field="place"
            :indicators="places"
            :objects="objects"
            :places="places"
            :mapTypes="mapTypes"
            :mapTypesWithPeriod="mapTypesWithPeriod"
            :mapScales="mapScales"
            :widthScales="widthScales"
            :mapTypesWithWidthScale="mapTypesWithWidthScale"
            :mapTypesSettingsAccordance="mapTypesSettingsAccordance"
            :fonts="fonts"
            :dimValues="dimValues"
            @svgLoaded="svgLoaded"
          />
          <report-maps
            ref="reportMaps"
            class="col-7 b-report-maps"
            :svg="svg"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </base-layout>
</template>

<script>
import BaseLayout from '@/Layouts/BaseLayout';
import UiBreadcrumbs from '@/components/Ui/UiBreadcrumbs';
import ReportSideBar from './ReportSideBar';
import ReportSideBarDates from './ReportSideBarDates';
import ReportSideBarMaps from './ReportSideBarMaps';
import ReportMain from './ReportMain';
import ReportMaps from './ReportMaps';

export default {
  name: "ReportGeneral",
  components: {
    ReportSideBar,
    UiBreadcrumbs,
    BaseLayout,
    ReportSideBarDates,
    ReportMain,
    ReportSideBarMaps,
    ReportMaps,
  },
  props: {
    places: {
      type: Array,
      required: true,
    },
    reports: {
      type: Object,
      required: true,
    },
    indicators: {
      type: Array,
      required: true,
    },
    mapTypes: {
      type: Array,
      required: true,
    },
    mapTypesWithPeriod: {
      type: Array,
      required: true,
    },
    mapScales: {
      type: Array,
      required: true,
    },
    widthScales: {
      type: Array,
      required: true,
    },
    mapTypesWithWidthScale: {
      type: Array,
      required: true,
    },
    mapTypesSettingsAccordance: {
      type: Array,
      required: true,
    },
    fonts: {
      type: Array,
      required: true,
    },
    dimValues: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      mapsSidebar: true,
      loading: false,
      place: null,
      startWork: null,
      endWork: null,
      numObjects: 0,
      numHorizons: 0,
      numProdWells: 0,
      numInjWells: 0,
      activeName: 'Maps',
      selectedReport: null,
      objects: null,
      svg: null,
      currentReport: null,
      currentReportData: null,
      reportCollection: { },
      reportDataCollection: { },
    };
  },
  mounted() {
    const places = Object.values(this.places);
    if (places.length > 0) {
      this.place = places[0];
      this.changePlace(this.place);
    }
    const reports = Object.keys(this.reports);
    if (reports.length > 0) {
      this.selectedReport = reports[0];
    }
    reports.forEach((item) => {
      this.reportCollection[item] = null;
      this.reportDataCollection[item] = null;
    });
  },
  methods: {
    toDateString(value) {
      const date = new Date(value);
      let month = date.getMonth() + 1;
      month = month < 10 ? `0${month}` : month;
      if (!!month) {
        return `${month}-${date.getFullYear()}`;
      } else {
        return '-';
      }
    },
    changeReportType(e) {
      if (this.reportData?.report !== e.paneName) {
        this.currentReport = this.reportCollection[e.paneName] ?? null;
        this.currentReportData = this.reportDataCollection[e.paneName] ?? null;
        this.$refs.sideBarReports.loadReportData(this.currentReportData);
      }
    },
    changePlace() {
      this.loading = true;
      this.$refs.sideBarReports.selectedObjects = [];
      this.$refs.sideBarMaps.selectedObjects = [];
      this.$refs.sideBarMaps.svg = null;
      this.svg = null;
      this.report = null;
      axios.get(route('reports.show', this.place))
        .then(res => {
          const data = res.data.data;
          this.objects = data.objects;
          this.startWork = data.stats.minDate;
          this.endWork = data.stats.maxDate;
          this.numObjects = data.stats.numObjects;
          this.numHorizons = data.stats.numHorizons;
          this.numProdWells = data.stats.numProdWells;
          this.numInjWells = data.stats.numInjWells;
        }).catch(err => {
        this.$notify.error({
          title: 'Ошибка',
          message: 'Не удалось получить информацию о месторождении',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    svgLoaded(value) {
      this.svg = value;
    },
    reportCreated(value) {
      this.currentReport = value[0];
      this.currentReportData = value[1];
      this.currentReportData.place = this.place;
      const reportType = value[1]['report'];
      this.reportCollection[reportType] = this.currentReport;
      this.reportDataCollection[reportType] = this.currentReportData;
    },
    toggleMapsSidebar() {
      this.mapsSidebar = !this.mapsSidebar;
      const reportMaps = this.$refs.reportMaps.$el;
      reportMaps?.classList?.toggle('col-12');
      reportMaps?.classList?.toggle('col-7');
    },
  },
}
</script>

<style scoped>
.b-field, .b-info-value {
  font-weight: bold;
  line-height: 150%;
  font-size: 24px;
}

.b-field, .b-info {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 30px;
}

.b-field {
  font-size: 32px;
  justify-items: center;
}

.b-latest-date {
  font-weight: 600;
  font-size: 16px;
  grid-column-start: 3;
  grid-column-end: 3;
}

.b-info > div {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  text-align: center;
  background-color: white;
  padding: 20px;
}

.b-description, .b-map {
  margin-top: 50px;
  padding: 20px;
  background-color: white;
}

.b-description > div:first-child, .b-map > div:first-child {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 15px;
}

.b-map img {
  width: 100%;
}

.b-info > div, .b-description, .b-map {
  border-radius: 3px;
  border: solid 1px #e5e5e5;
}
</style>

<style>
.el-tabs__content {
  overflow: unset;
}
</style>

<style>
.b-map-sidebar {
  display: grid;
  background-color: white;
  margin: 15px 0;
  padding: 25px;
  border-radius: 3px;
  border: solid 1px #e5e5e5;
}

.b-map-sidebar .b-map-sidebar-container > div {
  margin: 15px 0;
}

.b-map-sidebar-label {
  margin-bottom: 10px;
}

.b-single-select {
  width: 100%;
}

.b-single-row-element {
  display: grid;
  grid-template-columns: 1fr 0.4fr;
  align-items: center;
}

.b-label-bold {
  font-weight: 500;
}

.b-select-border-none {
  border: none;
}

.b-select-border-none:focus-visible {
  outline: none;
}

.b-button {
  width: 100%;
}

.b-disabled {
  background-color: #eaeaea;
}

.el-button + .el-button {
  margin-left: 0;
}

.b-datepicker-container .el-input {
  width: 100%;
}
</style>
